export default class {
    static AVATAR:string = 'avatar';
    static IMAGE:string = 'image';
    static VIDEO:string = 'video';
    static AUDIO:string = 'audio';
    static MUSIC:string = 'music';
}
